export default __webpack_public_path__ + "static/media/angers10.9b3bb7e4.jpg";